(ns rlws.iot-cloud.frontend.ajax
  (:require [ajax.core :as ajax]
            [ajax.protocols :as pr]
            [rlws.iot-cloud.frontend.authentication :as authn]
            [rlws.iot-cloud.frontend.ajax-common :as ajax-common]
            [clojure.string :as str]))

(defn request
  ([method uri on-success on-error]
   (request method uri on-success on-error nil))
  ([method uri on-success on-error params]
   {:http-xhrio (cond-> {:uri uri
                         :method method
                         ::authn/type ::authn/bearer
                         ::authn/in [:authentication]
                         :format (ajax/json-request-format)
                         :response-format ajax-common/detect-response-format
                         :headers {"Accept" "application/json"}
                         :on-success on-success
                         :on-failure [::authn/intercept-unauthorized on-error]}
                  params (assoc :params params))}))

(defn request-image
  [uri on-success on-error]
  (let [image-type ({"png" "png"
                     "svg" "svg+xml"} (last (str/split uri ".")))]
    {:http-xhrio {:uri uri
                  :method :get
                  ::authn/type ::authn/bearer
                  ::authn/in [:authentication]
                  :format (ajax/json-request-format)
                  :response-format (if (= "png" image-type)
                                     ajax-common/png-response-format
                                     ajax-common/detect-response-format)
                  :on-success (conj on-success image-type) ;; [::event image-type response]
                  :on-error [::authn/intercept-unauthorized on-error]}}))

(defn get-request
  [uri on-success on-error & [url-params]]
  (request :get uri on-success on-error url-params))

(defn put-request
  [uri params on-success on-error]
  (request :put uri on-success on-error params))

(defn post-request
  [uri params on-success on-error]
  (request :post uri on-success on-error params))

(defn delete-request
  [uri on-success on-error]
  (request :delete uri on-success on-error))
